import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({
    providedIn: 'root'
})
export class AlertService
{
    private toastController = inject(ToastController);

    async show(
        message: string | null = null,
        duration = 4000,
        header = '',
        position: 'top' | 'bottom' | 'middle' = 'bottom'
    )
    {
        if (message === null)
        {
            message = 'Please try again.';
        }

        const toast = await this.toastController.create({
            header,
            message,
            duration,
            position,
            animated: true,
            keyboardClose: false,
            buttons: [
                {
                    text: 'OK',
                    role: 'cancel',
                },
            ],
        });

        await toast.present();
    }

    showResponseError(response: HttpErrorResponse)
    {
        if (response.status === 401)
        {
            return;
        }

        if (!response.error || (!response.error.hasOwnProperty('message') && !response.error.hasOwnProperty('errors')))
        {
            // this.show(undefined, 'error');

            return;
        }

        if (response.error.message)
        {
            this.show(response.error.message);

            return;
        }

        const errors = response.error.errors;

        for (const key in errors)
        {
            if (errors.hasOwnProperty(key))
            {
                this.show(errors[key]);

                break;
            }
        }
    }
}
